import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "cameraInput", "libraryInput"]

  openCamera (event) {
    event.preventDefault()
    this.cameraInputTarget.click()
  }

  openLibrary (event) {
    event.preventDefault()
    this.libraryInputTarget.click()
  }

  submitOnSelect () {
    if (this.formTarget.requestSubmit) {
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.submit()
    }
  }
}
